import {TagAvatar} from '../documentation/chip/TagAvatar';
import {VariableAvatar} from '../documentation/chip/VariableAvatar';
import {TriggerAvatar} from '../documentation/chip/TriggerAvatar';
import * as Sentry from "@sentry/react";

//////////////
// This Script Formats the data to be displayed in the graph
////////////////
export const GraphData =(selectedTags, tagData, selectedTriggers, triggerData, selectedVariables, variableData) => {
  //console.log('GraphData')
  //console.log(selectedTags)
  let firstPass = mapNodes(selectedTags, tagData, selectedTriggers, triggerData, selectedVariables, variableData);
  //console.log(firstPass);
  let secondPass = mapNodes(firstPass.storage.tags, tagData, firstPass.storage.triggers, triggerData, firstPass.storage.variables, variableData);
  //console.log(secondPass);
  let finalData = replaceBlankImages(secondPass);

  return finalData;
}

function replaceBlankImages(data){
  let replacementImage = "data:image/png;base64,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";

  for( let i = 0 ; i < data.nodes.length ; i++ ){
    if(!data.nodes[i].image){
      data.nodes[i].image = replacementImage;
      Sentry.captureMessage("Missing Image - "+data.nodes[i].id+":"+data.nodes[i].label);
    }
  }
  return data;
}


function mapNodes(selectedTags, tagData, selectedTriggers, triggerData, selectedVariables, variableData){
  let nodes = [];
  let edges = [];
  let nodeStorage = {'tags':[],'triggers':[],'variables':[]};

  if(typeof selectedTags !== 'undefined'){
    //console.log('selected Tag within map Nodes')
    //console.log(selectedTags)
    selectedTags.forEach((selectTag)=>{
      //console.log(selectTag)

      if(typeof tagData !== 'undefined' && typeof selectTag !== 'undefined'){
        tagData.forEach((tagRow)=>{
          if(tagRow[0].id === selectTag.id){
            nodes.push({"id":"tag"+tagRow[0].id, "label":tagRow[0].name, "image":TagAvatar[tagRow[0].type],"shape":"circularImage"})
            nodeStorage.tags.push(tagRow[0]);

            tagRow[1].forEach((variables)=>{
              edges.push({"from":"tag"+tagRow[0].id, "to":"variable"+variables.id})
              nodes.push({"id":"variable"+variables.id, "label":variables.name, "image":VariableAvatar[variables.type],"shape":"circularImage"})
              nodeStorage.variables.push(variables);
            })
            tagRow[2].forEach((triggers)=>{
              edges.push({"from":"tag"+tagRow[0].id, "to":"trigger"+triggers.id})
              nodes.push({"id":"trigger"+triggers.id, "label":triggers.name, "image":TriggerAvatar[triggers.type],"shape":"circularImage"})
              nodeStorage.triggers.push(triggers);
            })
          }
        })
      }
    })
  }



// Looping through triggers
  if(typeof selectedTriggers !== 'undefined'){
    selectedTriggers.forEach((selectTrigger)=>{

      if(typeof triggerData !== 'undefined'){
        triggerData.forEach((triggerRow)=>{
          if(selectTrigger.id === triggerRow[0].id){
            nodes.push({"id":"trigger"+triggerRow[0].id, "label":triggerRow[0].name, "image":TriggerAvatar[triggerRow[0].type],"shape":"circularImage"});
            nodeStorage.triggers.push(triggerRow[0]);

            triggerRow[1].forEach((tags)=>{
              edges.push({"from":"trigger"+triggerRow[0].id, "to":"tag"+tags.id});
              nodes.push({"id":"tag"+tags.id, "label":tags.name, "image":TagAvatar[tags.type],"shape":"circularImage"});
              nodeStorage.tags.push(tags);
            })

            triggerRow[2].forEach((variables)=>{
              edges.push({"from":"trigger"+triggerRow[0].id, "to":"variable"+variables.id});
              nodes.push({"id":"variable"+variables.id, "label":variables.name, "image":VariableAvatar[variables.type],"shape":"circularImage"});
              nodeStorage.variables.push(variables);
            })
          }
        });
      }
    });
  }

  if(typeof selectedVariables !== 'undefined'){
    selectedVariables.forEach((selectVariable)=>{

      if(typeof variableData !== 'undefined'){
        variableData.forEach((variableRow)=>{
          if(selectVariable.id === variableRow[0].id){

              // Sets the node that was selected
              nodes.push({"id":"variable"+variableRow[0].id, "label":variableRow[0].name, "image":VariableAvatar[variableRow[0].type],"shape":"circularImage"})
              nodeStorage.variables.push(variableRow[0]);

              // Sets the Tag Relationship
              variableRow[1].forEach((tags)=>{
                edges.push({"from":"variable"+variableRow[0].id, "to":"tag"+tags.id})

                if(nodes.includes("tag"+tags.id) === false){
                  nodes.push({"id":"tag"+tags.id, "label":tags.name, "image":TagAvatar[tags.type],"shape":"circularImage"})
                  nodeStorage.tags.push(tags);
                }
              })

              // Sets the Trigger Relationships
              variableRow[2].forEach((triggers)=>{
                edges.push({"from":"variable"+variableRow[0].id, "to":"trigger"+triggers.id})

                if(nodes.includes("trigger"+triggers.id) === false){
                  nodes.push({"id":"trigger"+triggers.id, "label":triggers.name, "image":TriggerAvatar[triggers.type],"shape":"circularImage"})
                  nodeStorage.triggers.push(triggers);
                }
              })

              // Sets the Vars Referenced in other Vars
              variableRow[3].forEach((variables)=>{
                edges.push({"from":"variable"+variableRow[0].id, "to":"variable"+variables.id})

                if(nodes.includes("variable"+variables.id) === false){
                  nodes.push({"id":"variable"+variables.id, "label":variables.name, "image":VariableAvatar[variables.type],"shape":"circularImage"});
                  nodeStorage.variables.push(variables);
                }
              })

              // Sets the Vars are referenced in Parameters
              if(variableRow[4] !== null){
                variableRow[4].forEach((variables)=>{
                  edges.push({"from":"variable"+variableRow[0].id, "to":"variable"+variables.id})

                  if(nodes.includes("variable"+variables.id) === false){
                    nodes.push({"id":"variable"+variables.id, "label":variables.name, "image":VariableAvatar[variables.type],"shape":"circularImage"});
                    nodeStorage.variables.push(variables);
                  }
                })
              }
            }
        });
      }
    })
  }

// Dedup logic

  let output={'nodes': dedupObjectsInArray(nodes), 'edges':dedupObjectsInArray(edges), 'storage':nodeStorage};

  //console.log(JSON.stringify(output));
  //console.log(JSON.stringify(edges));

  return output;
}

function dedupObjectsInArray(nodes){
  let stringNodes = nodes.map(x=>JSON.stringify(x));
  //console.log(stringNodes);
  let dedupStringNodes = [...new Set(stringNodes)];
  //console.log(dedupStringNodes)
  let dedupObjectsNode =  dedupStringNodes.map(x=>JSON.parse(x));
  //console.log(dedupObjectsNode);
  return dedupObjectsNode
}
